module.exports = require("vue");


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 48
// module chunks = 0